import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { FrontMatterNodeView } from "@/components/editor/nodeviews/FrontMatterNodeView";

export const FrontMatterBlock = Node.create({
  name: "frontMatterBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      text: { default: "" },
      subType: { default: "titlePage" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="front-matter-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "front-matter-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(FrontMatterNodeView);
  },
});
